// getAllCommonInfos
export const GET_ALL_COMMONINFOS = 'commonInfo/GET_ALL_COMMONINFOS';
export const GET_ALL_COMMONINFOS_SUCCESS = 'commonInfo/GET_ALL_COMMONINFOS_SUCCESS';
export const GET_ALL_COMMONINFOS_FAIL = 'commonInfo/GET_ALL_COMMONINFOS_FAIL';
